import { useSyncExternalStore } from 'react';

export type SclaSavePhase = 'idle' | 'saving' | 'saved' | 'error';

type SaveSnapshot = {
  phase: SclaSavePhase;
  savedAt: number | null;
};

let snapshot: SaveSnapshot = { phase: 'idle', savedAt: null };
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach(listener => listener());
}

export function setSclaSaveStatus(phase: SclaSavePhase) {
  snapshot = {
    phase,
    savedAt: phase === 'saved' ? Date.now() : snapshot.savedAt,
  };
  emit();
}

export function resetSclaSaveStatus() {
  snapshot = { phase: 'idle', savedAt: null };
  emit();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function getSnapshot() {
  return snapshot;
}

export function useSclaSaveStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

export function sclaSaveStatusLabel(
  phase: SclaSavePhase,
  savedAt: number | null,
  now: number,
): string {
  if (phase === 'saving') return 'Saving…';
  if (phase === 'error') return "Couldn't save. Retrying…";
  if (savedAt) {
    const minutes = Math.floor((now - savedAt) / 60000);
    if (minutes < 1) return '✓ Saved just now';
    if (minutes === 1) return '✓ Saved 1 min ago';
    return `✓ Saved ${minutes} min ago`;
  }
  return 'Your answers save automatically';
}
